import { useState } from "react";
import { Layer } from "../../types/layer";
import ToolbarButton from "../toolbar/ToolbarButton";

/**
 * Factory that returns a raster layer for historical fire-scar imagery coming
 * from a TileJSON endpoint.
 *
 * The caller should provide an already-constructed raster source definition
 * (tiles / bounds / minzoom / maxzoom). All state (stale / active visibility)
 * can be managed by the caller, however for simple usage this helper sets the
 * layer to be permanently active and non-stale.
 */
const FireScarsLayer = (
  id: string,
  name: string,
  rasterSource: {
    tiles: string[];
    tileSize?: number;
    minzoom?: number;
    maxzoom?: number;
    bounds?: [number, number, number, number];
  }
): Layer => {
  const [active, setActive] = useState<boolean>(false);
  const [stale, setStale] = useState<boolean>(true);

  const toolbarButton = (
    <ToolbarButton
      key={id}
      id={id}
      name={name}
      toggledOn={active}
      enabled={true}
      onClick={() => {
        setActive((prev) => !prev);
        setStale(true);
      }}
      icon={"local_fire_department"}
    />
  );

  return {
    id,
    name,
    type: "raster", // interpreted by Map.tsx
    layerType: "raster",
    active,
    stale,
    setStale,
    onTop: false,
    source: rasterSource,
    layerStyle: {
      id,
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
        "raster-color": "#FF0000",
      },
      layout: {
        visibility: active ? "visible" : "none",
      },
    },
    toolbarButton: toolbarButton,
  };
};

export default FireScarsLayer;
